import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ArticleComponent } from './pages/article/article.component';
import { CategoryComponent } from './pages/category/category.component';
import { HomeComponent } from './pages/home/home.component';
import { ScheduleCallComponent } from './pages/schedule-call/schedule-call.component';
import { SearchComponent } from './pages/search/search.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: {
      title: 'Support documentation',
    },
  },
  {
    path: 'category/:slug',
    component: CategoryComponent,
  },
  {
    path: 'article/:slug',
    component: ArticleComponent,
  },
  {
    path: 'search',
    component: SearchComponent,
  },
  {
    path: 'schedule-a-call',
    component: ScheduleCallComponent,
    data: {
      title: 'Schedule a call',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupportDocumentationRoutingModule {}
